import React, { memo, Fragment } from 'react';
import { string } from 'prop-types';
import { UTLabel, WithLoading } from '@widergy/energy-ui';

import UTForm from 'app/components/UTForm';
import { message } from 'utils/stringUtils';
import { codeField } from 'constants/fields';

import styles from './styles.module.scss';

const fields = [codeField];

const EmailValidation = ({ userEmail }) => (
  <Fragment>
    <UTLabel darkGray style={styles.codeSentLabel}>
      {message('Signup:codeSent', { userEmail })}
    </UTLabel>
    <UTForm fields={fields} fieldClasses={{ container: styles.field }} />
  </Fragment>
);

EmailValidation.propTypes = {
  userEmail: string
};
export default WithLoading(props => props.loading)(memo(EmailValidation));
